// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"c723f536","239":"0e3a5b9d","378":"91c82724","732":"df470f13","977":"26770cd7"}[chunkId] + ".chunk.js";
};